import Layout from "@/components/layout";
import Empty from "@/components/empty";
const router = [
  {
    path: "/",
    name: "/",
    component: Layout,
    // redirect: "/cashier",
    children: [
      {
        path: "/cashier",
        name: "Cashier",
        component: resolve => require(["@/views/cashier/index.vue"], resolve),
        meta: {
          title: "收银台"
        }
      },
      {
        path: "/dashboard",
        name: "DashBoard",
        component: resolve => require(["@/views/dashboard.vue"], resolve),
        meta: {
          title: "DashBoard"
        }
      }
    ]
  },
  {
    path: "/account",
    name: "Account",
    component: Empty,
    meta: {
      title: "账号"
    },
    children: [
      {
        path: "login",
        name: "Login",
        component: resolve => require(["@/views/account/login.vue"], resolve),
        meta: {
          title: "用户登录"
        }
      },
      {
        path: "reset",
        name: "Reset",
        component: resolve => require(["@/views/account/reset.vue"], resolve),
        meta: {
          title: "找回免密"
        }
      },
      {
        path: "register",
        name: "Register",
        component: resolve =>
          require(["@/views/account/register.vue"], resolve),
        meta: {
          title: "用户注册"
        }
      }
    ]
  },

  {
    path: "/order",
    name: "Order",
    component: Layout,
    meta: {
      title: "交易管理"
    },
    children: [
      {
        path: "serviceorder",
        name: "ServiceOrder",
        component: resolve =>
          require(["@/views/order/serviceorder/index.vue"], resolve),
        meta: {
          title: "服务订单"
        }
      },
      {
        path: "sportorder",
        name: "SportOrder",
        component: resolve =>
          require(["@/views/order/sportorder/index.vue"], resolve),
        meta: {
          title: "运动订单"
        }
      },
      {
        path: "productorder",
        name: "ProductOrder",
        component: resolve =>
          require(["@/views/order/productorder/index.vue"], resolve),
        meta: {
          title: "产品订单"
        }
      },
      {
        path: "rechargeorder",
        name: "RechargeOrder",
        component: resolve =>
          require(["@/views/order/rechargeorder/index.vue"], resolve),
        meta: {
          title: "充值订单"
        }
      },
      {
        path: "couponorder",
        name: "CouponOrder",
        component: resolve =>
          require(["@/views/order/couponorder/index.vue"], resolve),
        meta: {
          title: "美团订单"
        }
      },
      {
        path: "otherorder",
        name: "OtherOrder",
        component: resolve =>
          require(["@/views/order/otherorder/index.vue"], resolve),
        meta: {
          title: "严选订单"
        }
      },
      {
        path: "refundserviceorder",
        name: "RefundServiceOrder",
        component: resolve =>
          require(["@/views/order/refundserviceorder/index.vue"], resolve),
        meta: {
          title: "服务订单退款"
        }
      },
      {
        path: "refundrechargeorder",
        name: "RefundRechargeOrder",
        component: resolve =>
          require(["@/views/order/refundrechargeorder/index.vue"], resolve),
        meta: {
          title: "充值订单退款"
        }
      },
      {
        path: "refundproductorder",
        name: "RefundProductOrder",
        component: resolve =>
          require(["@/views/order/refundproductorder/index.vue"], resolve),
        meta: {
          title: "零售订单退款"
        }
      },
      {
        path: "refundcardorder",
        name: "RefundCardOrder",
        component: resolve =>
          require(["@/views/order/refundcardorder/index.vue"], resolve),
        meta: {
          title: "会员卡退款"
        }
      },
      {
        path: "crossstoreorder",
        name: "CrossStoreOrder",
        component: resolve =>
          require(["@/views/order/crossstoreorder/index.vue"], resolve),
        meta: {
          title: "跨店消费记录"
        }
      },
      {
        path: "invoiceorder",
        name: "InvoiceOrder",
        component: resolve =>
          require(["@/views/order/invoiceorder/index.vue"], resolve),
        meta: {
          title: "发票管理"
        }
      }
    ]
  },
  {
    path: "/customer",
    name: "Customer",
    component: Layout,
    meta: {
      title: "客户管理"
    },
    children: [
      {
        path: "customercenter",
        name: "CustomerCenter",
        component: resolve =>
          require(["@/views/customer/customercenter/index.vue"], resolve),
        meta: {
          title: "客户中心"
        }
      },
      {
        path: "customer",
        name: "Customer_",
        component: resolve =>
          require(["@/views/customer/customer/index.vue"], resolve),
        meta: {
          title: "客户信息"
        }
      },
      {
        path: "mycard",
        name: "MyCard",
        component: resolve =>
          require(["@/views/customer/mycard/index.vue"], resolve),
        meta: {
          title: "会员卡信息"
        }
      },
      {
        path: "mycoupon",
        name: "MyCoupon",
        component: resolve =>
          require(["@/views/customer/mycoupon/index.vue"], resolve),
        meta: {
          title: "优惠券信息"
        }
      },
      {
        path: "giftcard",
        name: "CustomerGiftCard",
        component: resolve =>
          require(["@/views/customer/giftcard/index.vue"], resolve),
        meta: {
          title: "优惠券信息"
        }
      },
      {
        path: "transfermycard",
        name: "TransferMyCard",
        component: resolve =>
          require(["@/views/customer/transfermycard/index.vue"], resolve),
        meta: {
          title: "转账申请管理"
        }
      },
      {
        path: "adjustmycard",
        name: "AdjustMycard",
        component: resolve =>
          require(["@/views/customer/adjustmycard/index.vue"], resolve),
        meta: {
          title: "余额调整管理"
        }
      },
      {
        path: "limit",
        name: "Limit",
        component: resolve =>
          require(["@/views/customer/limit/index.vue"], resolve),
        meta: {
          title: "客户限制"
        }
      }
    ]
  },
  {
    path: "/employee",
    name: "employee",
    component: Layout,
    meta: {
      title: "员工管理"
    },
    children: [
      {
        path: "storeemployee",
        name: "StoreEmployee",
        component: resolve =>
          require(["@/views/employee/storeemployee/index.vue"], resolve),
        meta: {
          title: "员工信息"
        }
      },
      {
        path: "scheduling",
        name: "Scheduling",
        component: resolve =>
          require(["@/views/employee/scheduling/index.vue"], resolve),
        meta: {
          title: "排班管理"
        }
      },
      {
        path: "checkwork",
        name: "CheckWork",
        component: resolve =>
          require(["@/views/employee/checkwork/index.vue"], resolve),
        meta: {
          title: "工作台管理"
        }
      },
      {
        path: "pl",
        name: "Pl",
        component: resolve =>
          require(["@/views/employee/pl/index.vue"], resolve),
        meta: {
          title: "PL管理"
        }
      },
      {
        path: "schedulingtype",
        name: "SchedulingTypeInfo",
        component: resolve =>
          require(["@/views/employee/schedulingtype/index.vue"], resolve),
        meta: {
          title: "排班类型"
        }
      },
      {
        path: "signinfo",
        name: "SignInfo",
        component: resolve =>
          require(["@/views/employee/signinfo/index.vue"], resolve),
        meta: {
          title: "信息登记"
        }
      },
      {
        path: "employeetransfer",
        name: "EmployeeTransfer",
        component: resolve =>
          require(["@/views/employee/employeetransfer/index.vue"], resolve),
        meta: {
          title: "员工借调"
        }
      },
      {
        path: "rating",
        name: "Rating",
        component: resolve =>
          require(["@/views/employee/rating/index.vue"], resolve),
        meta: {
          title: "评级管理"
        }
      }
    ]
  },
  {
    path: "/store",
    name: "Store",
    component: Layout,
    meta: {
      title: "门店管理"
    },
    children: [
      {
        path: "storeinfo",
        name: "StoreInfo",
        component: resolve =>
          require(["@/views/store/store/index.vue"], resolve),
        meta: {
          title: "门店信息"
        }
      },
      {
        path: "room",
        name: "Room",
        component: resolve =>
          require(["@/views/store/room/index.vue"], resolve),
        meta: {
          title: "房间信息"
        }
      }
    ]
  },
  {
    path: "/project",
    name: "Project",
    component: Layout,
    meta: {
      title: "项目管理"
    },
    children: [
      {
        path: "storecard",
        name: "StoreCard",
        component: resolve =>
          require(["@/views/project/storecard/index.vue"], resolve),
        meta: {
          title: "门店会员卡管理"
        }
      },
      {
        path: "itemclassify",
        name: "ItemClassify",
        component: resolve =>
          require(["@/views/project/itemclassify/index.vue"], resolve),
        meta: {
          title: "商品分类"
        }
      },
      {
        path: "serviceclassify",
        name: "ServiceClassify",
        component: resolve =>
          require(["@/views/project/serviceclassify/index.vue"], resolve),
        meta: {
          title: "服务分类"
        }
      },

      {
        path: "productclassify",
        name: "ProductClassify",
        component: resolve =>
          require(["@/views/project/productclassify/index.vue"], resolve),
        meta: {
          title: "产品分类"
        }
      },

      {
        path: "storeproduct",
        name: "StoreProduct",
        component: resolve =>
          require(["@/views/project/storeproduct/index.vue"], resolve),
        meta: {
          title: "门店产品管理"
        }
      },
      {
        path: "storeservice",
        name: "StoreService",
        component: resolve =>
          require(["@/views/project/storeservice/index.vue"], resolve),
        meta: {
          title: "门店服务管理"
        }
      },
      {
        path: "storegiftcard",
        name: "StoreGiftCard",
        component: resolve =>
          require(["@/views/project/storegiftcard/index.vue"], resolve),
        meta: {
          title: "门店礼券卡项目管理"
        }
      },
      {
        path: "storegiftcardproject",
        name: "StoreGiftCardProject",
        component: resolve =>
          require(["@/views/project/storegiftcardproject/index.vue"], resolve),
        meta: {
          title: "门店礼券卡项目管理"
        }
      }
    ]
  },
  {
    path: "/market",
    name: "Market",
    component: Layout,
    meta: {
      title: "活动管理"
    },
    children: [
      {
        path: "marketing",
        name: "Marketing",
        component: resolve =>
          require(["@/views/market/marketing/index.vue"], resolve),
        meta: {
          title: "营销活动"
        }
      }
    ]
  },
  {
    path: "/item",
    name: "Item",
    component: Layout,
    meta: {
      title: "品相管理"
    },
    children: [
      {
        path: "service",
        name: "Service",
        component: resolve =>
          require(["@/views/item/service/index.vue"], resolve),
        meta: {
          title: "服务管理"
        }
      },
      {
        path: "item",
        name: "ProductItem",
        component: resolve => require(["@/views/item/item/index.vue"], resolve),
        meta: {
          title: "商品管理"
        }
      },
      {
        path: "product",
        name: "Product",
        component: resolve =>
          require(["@/views/item/product/index.vue"], resolve),
        meta: {
          title: "产品管理"
        }
      },
      {
        path: "card",
        name: "Card",
        component: resolve => require(["@/views/item/card/index.vue"], resolve),
        meta: {
          title: "会员卡管理"
        }
      },
      {
        path: "coupon",
        name: "Coupon",
        component: resolve =>
          require(["@/views/item/coupon/index.vue"], resolve),
        meta: {
          title: "优惠券管理"
        }
      },
      {
        path: "giftcard",
        name: "GiftCard",
        component: resolve =>
          require(["@/views/item/giftcard/index.vue"], resolve),
        meta: {
          title: "礼券卡管理"
        }
      },
      {
        path: "cooperateitem",
        name: "CooperateItem",
        component: resolve =>
          require(["@/views/item/cooperateitem/index.vue"], resolve),
        meta: {
          title: "美团项目"
        }
      },
      {
        path: "contract",
        name: "Contract",
        component: resolve =>
          require(["@/views/item/contract/index.vue"], resolve),
        meta: {
          title: "合约项目"
        }
      }
    ]
  },
  {
    path: "/menu",
    name: "Menu",
    component: Layout,
    meta: {
      title: "电子菜单"
    },
    children: [
      {
        path: "menuitem",
        name: "MenuItem",
        component: resolve =>
          require(["@/views/menu/menuitem/index.vue"], resolve),
        meta: {
          title: "菜单项目"
        }
      },
      {
        path: "storemenuitem",
        name: "StoreMenuItem",
        component: resolve =>
          require(["@/views/menu/storemenuitem/index.vue"], resolve),
        meta: {
          title: "门店菜单项目"
        }
      }
    ]
  },
  {
    path: "/finance",
    name: "Finance",
    component: Layout,
    meta: {
      title: "财务管理"
    },
    children: [
      {
        path: "tradeorder",
        name: "TradeOrder",
        component: resolve =>
          require(["@/views/finance/tradeorder/index.vue"], resolve),
        meta: {
          title: "银行交易单"
        }
      },
      {
        path: "settlementorder",
        name: "SettlementOrder",
        component: resolve =>
          require(["@/views/finance/settlementorder/index.vue"], resolve),
        meta: {
          title: "结算单"
        }
      },
      {
        path: "settlementorderdetail",
        name: "SettlementOrderDetail",
        component: resolve =>
          require(["@/views/finance/settlementorderdetail/index.vue"], resolve),
        meta: {
          title: "结算单详情"
        }
      },
      {
        path: "storepayment",
        name: "StorePayment",
        component: resolve =>
          require(["@/views/finance/storepayment/index.vue"], resolve),
        meta: {
          title: "结算信息"
        }
      }
    ]
  },
  {
    path: "/baseinfo",
    name: "BaseInfo",
    component: Layout,
    meta: {
      title: "基础设置"
    },
    children: [
      {
        path: "module",
        name: "Module",
        component: resolve =>
          require(["@/views/baseinfo/module/index.vue"], resolve),
        meta: {
          title: "模块管理"
        }
      },
      {
        path: "financeinfo",
        name: "FinanceInfo",
        component: resolve =>
          require(["@/views/baseinfo/financeinfo/index.vue"], resolve),
        meta: {
          title: "门店财务信息"
        }
      },
      {
        path: "device",
        name: "Device",
        component: resolve =>
          require(["@/views/baseinfo/device/index.vue"], resolve),
        meta: {
          title: "设备管理"
        }
      },
      {
        path: "openplatformstore",
        name: "OpenPlatformStore",
        component: resolve =>
          require(["@/views/baseinfo/openplatformstore/index.vue"], resolve),
        meta: {
          title: "合作公司"
        }
      },
      {
        path: "storeopenplatform",
        name: "StoreOpenPlatform",
        component: resolve =>
          require(["@/views/baseinfo/storeopenplatform/index.vue"], resolve),
        meta: {
          title: "合作平台"
        }
      },
      {
        path: "customertag",
        name: "CustomerTag",
        component: resolve =>
          require(["@/views/baseinfo/customertag/index.vue"], resolve),
        meta: {
          title: "客户标签"
        }
      },
      {
        path: "customersource",
        name: "CustomerSource",
        component: resolve =>
          require(["@/views/baseinfo/customersource/index.vue"], resolve),
        meta: {
          title: "客户来源"
        }
      },
      {
        path: "paytype",
        name: "PayType",
        component: resolve =>
          require(["@/views/baseinfo/paytype/index.vue"], resolve),
        meta: {
          title: "支付方式"
        }
      }
    ]
  },
  // {
  //   path: '/finance',
  //   name: 'Finance',
  //   component: Layout,
  //   meta: {
  //     title: '财务管理',
  //   },
  //   children: [
  //     {
  //       path: 'invoiceaccount',
  //       name: 'InvoiceAccount',
  //       component: resolve => require(['@/views/finance/invoiceaccount/index.vue'], resolve),
  //       meta: {
  //         title: '门店发票信息',
  //       },
  //     },
  //     {
  //       path: 'tradeorder',
  //       name: 'TradeOrder',
  //       component: resolve => require(['@/views/finance/tradeorder/index.vue'], resolve),
  //       meta: {
  //         title: '银行交易单',
  //       },
  //     },
  //     {
  //       path: 'invoicetaxmark',
  //       name: 'invoiceTaxMark',
  //       component: resolve => require(['@/views/finance/invoicetaxmark/index.vue'], resolve),
  //       meta: {
  //         title: '商品管理',
  //       },
  //     },
  //     {
  //       path: 'invoiceitem',
  //       name: 'invoiceItem',
  //       component: resolve => require(['@/views/finance/invoiceitem/index.vue'], resolve),
  //       meta: {
  //         title: '商品管理',
  //       },
  //     },
  //     {
  //       path: 'settlementorder',
  //       name: 'SettlementOrder',
  //       component: resolve => require(['@/views/finance/settlementorder/index.vue'], resolve),
  //       meta: {
  //         title: '结算单',
  //       },
  //     },
  //     {
  //       path: 'settlementorderdetail',
  //       name: 'SettlementOrderDetail',
  //       component: resolve => require(['@/views/finance/settlementorderdetail/index.vue'], resolve),
  //       meta: {
  //         title: '结算单详情',
  //       },
  //     },
  //      {
  //       path: 'invoiceorder',
  //       name: 'FinanceInvoiceOrder',
  //       component: resolve => require(['@/views/finance/invoiceorder/index.vue'], resolve),
  //       meta: {
  //         title: '发票管理',
  //       },
  //     }
  //   ]
  // },
  {
    path: "/hr",
    name: "Hr",
    component: Layout,
    meta: {
      title: "人事管理"
    },
    children: [
      {
        path: "company",
        name: "Company",
        component: resolve =>
          require(["@/views/hr/company/index.vue"], resolve),
        meta: {
          title: "公司管理"
        }
      },
      {
        path: "post",
        name: "Post",
        component: resolve => require(["@/views/hr/post/index.vue"], resolve),
        meta: {
          title: "岗位管理"
        }
      },
      {
        path: "platformemployee",
        name: "PlatformEmployee",
        component: resolve =>
          require(["@/views/hr/platformemployee/index.vue"], resolve),
        meta: {
          title: "员工管理"
        }
      },
      {
        path: "role",
        name: "Role",
        component: resolve => require(["@/views/hr/role/index.vue"], resolve),
        meta: {
          title: "角色管理"
        }
      }
    ]
  },
  {
    path: "/report",
    name: "Report",
    component: Layout,
    meta: {
      title: "数据中心"
    },
    children: [
      {
        path: "businessreport",
        name: "BusinessReport",
        component: resolve =>
          require(["@/views/report/businessreport/index.vue"], resolve),
        meta: {
          title: "营业汇总"
        }
      },
      {
        path: "serviceorderreport",
        name: "ServiceOrderReport",
        component: resolve =>
          require(["@/views/report/serviceorderreport/index.vue"], resolve),
        meta: {
          title: "消费订单统计表"
        }
      },
      {
        path: "couponorder",
        name: "CouponOrderReport",
        component: resolve =>
          require(["@/views/report/couponorder/index.vue"], resolve),
        meta: {
          title: "优惠券订单"
        }
      },
      {
        path: "refundserviceorder",
        name: "RefundServiceOrderReport",
        component: resolve =>
          require(["@/views/report/refundserviceorder/index.vue"], resolve),
        meta: {
          title: "消费订单退款统计表"
        }
      },
      {
        path: "rechargeorder",
        name: "RechargeOrderReport",
        component: resolve =>
          require(["@/views/report/rechargeorder/index.vue"], resolve),
        meta: {
          title: "充值订单统计表"
        }
      },
      {
        path: "refundrechargeorder",
        name: "RefundRechargeOrderReport",
        component: resolve =>
          require(["@/views/report/refundrechargeorder/index.vue"], resolve),
        meta: {
          title: "充值订单退款统计表"
        }
      },
      {
        path: "productorder",
        name: "ProductOrderReport",
        component: resolve =>
          require(["@/views/report/productorder/index.vue"], resolve),
        meta: {
          title: "零售订单统计表"
        }
      },
      {
        path: "refundproductorder",
        name: "RefundProductOrderReport",
        component: resolve =>
          require(["@/views/report/refundproductorder/index.vue"], resolve),
        meta: {
          title: "零售订单退款统计表"
        }
      },
      {
        path: "beauticianperformance",
        name: "BeauticianPerformance",
        component: resolve =>
          require(["@/views/report/beauticianperformance/index.vue"], resolve),
        meta: {
          title: "理疗师绩效明细表"
        }
      },
      {
        path: "adviserperformance",
        name: "AdviserPerformance",
        component: resolve =>
          require(["@/views/report/adviserperformance/index.vue"], resolve),
        meta: {
          title: "顾问绩效明细表"
        }
      },
      {
        path: "summarybeauticianperformance",
        name: "SummaryBeauticianPerformance",
        component: resolve =>
          require([
            "@/views/report/summarybeauticianperformance/index.vue"
          ], resolve),
        meta: {
          title: "理疗师绩效统计表"
        }
      },
      {
        path: "summaryadviserperformance",
        name: "SummaryAdviserPerformance",
        component: resolve =>
          require([
            "@/views/report/summaryadviserperformance/index.vue"
          ], resolve),
        meta: {
          title: "顾问绩效统计表"
        }
      },
      {
        path: "employeeperformance",
        name: "EmployeePerformance",
        component: resolve =>
          require(["@/views/report/employeeperformance/index.vue"], resolve),
        meta: {
          title: "员工绩效"
        }
      },
      {
        path: "oil",
        name: "Oil",
        component: resolve =>
          require(["@/views/report/oil/index.vue"], resolve),
        meta: {
          title: "精油测试统计表"
        }
      },
      {
        path: "settlementdetail",
        name: "SettlementDetail",
        component: resolve =>
          require(["@/views/report/settlementdetail/index.vue"], resolve),
        meta: {
          title: "结算信息"
        }
      },

      {
        path: "mycardreport",
        name: "MyCardReport",
        component: resolve =>
          require(["@/views/report/mycardreport/index.vue"], resolve),
        meta: {
          title: "会员卡统计表"
        }
      },
      {
        path: "mycouponreport",
        name: "MyCouponReport",
        component: resolve =>
          require(["@/views/report/mycouponreport/index.vue"], resolve),
        meta: {
          title: "优惠券统计表"
        }
      },
      {
        path: "monthmemberclassifyreport",
        name: "MonthMemberClassifyReport",
        component: resolve =>
          require([
            "@/views/report/monthmemberclassifyreport/index.vue"
          ], resolve),
        meta: {
          title: "会员分类月报"
        }
      },
        {
        path: "customerclassifyreport",
        name: "CustomerClassifyReport",
        component: resolve =>
          require([
            "@/views/report/customerclassifyreport/index.vue"
          ], resolve),
        meta: {
          title: "会员分类"
        }
      },
      {
        path: "daymemberclassifyreport",
        name: "DayMemberClassifyReport",
        component: resolve =>
          require([
            "@/views/report/daymemberclassifyreport/index.vue"
          ], resolve),
        meta: {
          title: "会员分类日报"
        }
      },
      {
        path: "customersourcereport",
        name: "CustomerSourceReport",
        component: resolve =>
          require(["@/views/report/customersourcereport/index.vue"], resolve),
        meta: {
          title: "渠道来源统计表"
        }
      },
      {
        path: "memberanalysisreport",
        name: "MemberAnalysisReport",
        component: resolve =>
          require(["@/views/report/memberanalysisreport/index.vue"], resolve),
        meta: {
          title: "会员分析统计表"
        }
      },
      {
        path: "saleitemreport",
        name: "SaleItemReport",
        component: resolve =>
          require(["@/views/report/saleitemreport/index.vue"], resolve),
        meta: {
          title: "品相销售统计表"
        }
      },
      {
        path: "commentreport",
        name: "CommentReport",
        component: resolve =>
          require(["@/views/report/commentreport/index.vue"], resolve),
        meta: {
          title: "评价统计表"
        }
      },
      {
        path: "paymentreport",
        name: "PaymentReport",
        component: resolve =>
          require(["@/views/report/paymentreport/index.vue"], resolve),
        meta: {
          title: "收支统计表"
        }
      },
      {
        path: "memberstatusreport",
        name: "MemberStatusReport",
        component: resolve =>
          require(["@/views/report/memberstatusreport/index.vue"], resolve),
        meta: {
          title: "入会会员状态追踪"
        }
      },
      {
        path: "consumememberstatusreport",
        name: "ConsumeMemberStatusReport",
        component: resolve =>
          require(["@/views/report/consumememberstatusreport/index.vue"], resolve),
        meta: {
          title: "到店会员状态追踪"
        }
      },
      {
        path: "consumememberstatusinforeport",
        name: "ConsumeMemberStatusInfoReport",
        component: resolve =>
          require(["@/views/report/consumememberstatusinforeport/index.vue"], resolve),
        meta: {
          title: "到店会员消费前状态"
        }
      }
    ]
  },
  {
    path: "/safe",
    name: "Safe",
    component: Layout,
    meta: {
      title: "安全中心"
    },
    children: [
      {
        path: "ordermonitor",
        name: "OrderMonitor",
        component: resolve =>
          require(["@/views/safe/ordermonitor/index.vue"], resolve),
        meta: {
          title: "订单监控"
        }
      }
    ]
  }
];

export default router;



// WEBPACK FOOTER //
// ./src/router/defaultRouter.js